
  import { css } from 'lit';
  export const styles = css`:host{--menu-mini-width: 2.5rem}[part=base],[part~=mini]{border:.0625rem solid var(--border-color)}`;
  